import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Theme } from "../styles/styles";
import { Box, Checkbox, Typography } from '@mui/material';
import { ThemeProvider } from "@mui/material/styles";


export const AcceptConsent = ({ label, checked, handleChange }) => {

    

    

    return (
        <Box
            sx={{
                display: "flex",
                //justifyContent: "space-around",
                alignItems:"flex-start",
                //width: "100%"

            }}
        >
            <ThemeProvider theme={Theme}>
                <Checkbox 
                checked={checked}
                onChange={handleChange}
                sx={{mt:"-7px"}}
                
                />
                <Typography variant="bodyMediumRegural" color="#FE1919" sx={{fontSize:"20px", mt:"-2px"}}>
                    *
                </Typography>
                <Typography variant="bodyMediumRegural" sx={{ml:"8px"}}>
                    {label}
                </Typography>
            </ThemeProvider>

        </Box>
    )
}